module.exports = __webpack_public_path__ + "static/img/u44.05ec53a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kexie/regen/u44.png
// module id = EPfO
// module chunks = 0